var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "font14" }, [
    _c(
      "div",
      [
        _c("informacoes-pessoa", {
          staticClass: "pad",
          attrs: { pessoa: _vm.beneficiario.pessoa }
        }),
        _vm.beneficiario.qualificacao
          ? _c("informacoes-qualificacao", {
              attrs: {
                cadastroOriginal: _vm.cadastroOriginal,
                qualificacao: _vm.beneficiario.qualificacao,
                isBeneficiario: true
              }
            })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "pad-side" }, [
      _vm.isCasado
        ? _c(
            "div",
            [
              _c("app-divider", { attrs: { label: "Dados do cônjuge" } }),
              _c("informacoes-pessoa", {
                staticClass: "pad",
                attrs: {
                  pessoa: _vm.beneficiario.conjuge.pessoa,
                  isConjuge: true
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.isViuvo
        ? _c(
            "div",
            [
              _c("app-divider", { attrs: { label: "Dados do cônjuge" } }),
              _c("div", { staticClass: "pad-side" }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Possui certidão de óbito?")
                  ]),
                  _c("span", [_vm._v("  " + _vm._s(_vm.hasCertidao))])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("CPF:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.filterNull(
                            _vm.beneficiario.conjuge.pessoa.pessoaFisica.cpf
                          )
                        )
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Nome:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.filterNull(
                            _vm.beneficiario.conjuge.pessoa.pessoaFisica.nome
                          )
                        )
                    )
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ab2d286", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab2d286","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppVisualizarBeneficiario.vue
// module id = null
// module chunks = 